import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo2.svg'
import _imports_1 from '@/assets/img/logo_full.png'
import _imports_2 from '@/assets/img/graphic/register-banner.jpg'


const _withScopeId = n => (_pushScopeId("data-v-2c1546a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "registration-wrapper"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "icon icon-back"
}
const _hoisted_4 = {
  key: 1,
  class: "registration--desktop--wrapper"
}
const _hoisted_5 = { class: "header--desktop" }
const _hoisted_6 = { class: "registration--container" }
const _hoisted_7 = {
  key: 0,
  class: "logo--desktop",
  src: _imports_0,
  alt: ""
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo--desktop",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "registration--container--sm" }
const _hoisted_10 = { class: "registration--content" }
const _hoisted_11 = { class: "registration--content--body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title--page" }, "Create Your Account", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img--wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "banner"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_StepTitle = _resolveComponent("StepTitle")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.hideHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_app_header, { "custom-title": " " }, {
                "top-left": _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"])),
                    class: "back-link"
                  }, [
                    (_ctx.backArrow)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_StepTitle, {
          title: _ctx.title,
          subtitle: _ctx.subtitle,
          "subtitle-link": _ctx.subtitleLink,
          error: _ctx.error
        }, null, 8, ["title", "subtitle", "subtitle-link", "error"]),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            false
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { onOnSubmit: _ctx.hideLogin }, null, 8, ["onOnSubmit"]))
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_13
      ]))
}